import { ReactNode } from 'react'
import { Loader } from '../Loader/Loader'
import { button } from './Button.css'

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  className?: string
  label: ReactNode
  type?: 'primary' | 'secondary'
  mini?: boolean
  disabled?: boolean
  loading?: boolean
  rounded?: boolean
  dataTestId?: string
}

const Button = ({
  className = '',
  label,
  type = 'primary',
  mini = false,
  disabled = false,
  loading,
  rounded = false,
  dataTestId,
  ...otherProps
}: ButtonProps) => {
  return (
    <button
      className={`${button[type]} ${mini ? button['mini'] : ''} ${
        rounded ? button['rounded'] : ''
      } ${disabled || loading ? button['disabled'] : ''} ${className}`}
      data-testid={dataTestId}
      {...otherProps}
    >
      {loading ? <Loader /> : label}
    </button>
  )
}

export default Button
